import { makeStyles } from '@mui/styles'

export default makeStyles((theme: any) => ({
    UserMenu: {},

    UserMenuActionButtonIcon: {
        cursor: 'pointer',
        display: 'flex',
        background: 'transparent',
        alignItems: 'center',
        paddingLeft: 0,
        justifyContent: 'center',
    },

    UserMenuStaticCloseButtonIcon: {
        position: 'absolute',
        top: 0,
        right: 0,
        background: 'transparent',
        border: '2px solid #ffffff',
        boxShadow: 'none',
        transform: 'translateY(-125%)',
        width: '2.5rem',
        height: '2.5rem',
        '& svg': {
            width: '.8rem',
            height: '.8rem',
            '& *': {
                fill: '#ffffff !important',
                stroke: '#ffffff !important',
            },
        },
    },

    UserMenuDialog: {
        zIndex: '999999 !important',
        [theme.breakpoints.up(theme.constants.formats.breakpoint)]: {
            '& .MuiBackdrop-root': {
                display: 'none',
            },
        },
    },

    UserMenuDialogPaper: {
        minWidth: '80%',
        maxWidth: '95%',
        padding: '1rem',
        position: 'fixed',
        [theme.breakpoints.up(theme.constants.formats.breakpoint)]: {
            minWidth: '19rem',
            maxWidth: '40vw',
            boxShadow: '0 6px 14px rgba(158, 171, 191, 0.3)',
        },
    },

    UserMenuDialogPaperFloating: {
        right: '1.5rem',
        left: 'unset',
        top: '3.5rem',
        bottom: 'unset',
    },

    UserMenuDialogPaperStatic: {
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        overflowY: 'visible',
    },

    UserMenuDialogInfos: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },

    UserMenuDialogInfosVersion: {
        color: theme.palette.darkGrey.main,
    },

    UserMenuButton: {
        width: '100%',
        padding: '.5rem 1.1rem',
    },

    UserMenuMenuItem: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '9px',
        padding: '0',
    },

    UserMenuMenuItemButton: {
        padding: '0',
        marginBottom: '1rem',
    },

    UserMenuButtonTypeLogout: {
        background: theme.palette.hardRedRose.main,
        '&:hover': {
            background: theme.palette.hardRedRose.light,
        },
    },

    UserMenuMenuItemBorder: {
        width: '100%',
        height: '1px',
        background: theme.palette.lightGrey.main,
        margin: '.3rem 0',
        opacity: '0.7',
    },

    UserMenuMenuItemBorderDarker: {
        background: theme.palette.lightGrey.border,
        marginBottom: '.5rem',
        opacity: '1',
    },

    UserMenuActionSeparator: {
        width: '100%',
        height: '1px',
        margin: '.3rem 0',
        background: theme.palette.lightGrey.border,
        marginBottom: '.5rem',
        opacity: '1',
    },
    UserMenuNotification:  {
        background: theme.palette.red.main,
        top: '.3rem',
        right: '-.3rem'
    },

    UserMenuButtonName: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        fontSize: '.9rem',
        lineHeight: '.9rem',
        textTransform: 'initial',
    },
}))

